import { Component, Suspense } from 'react'
import { connect } from 'react-redux'
import { getNominative, sortList } from '../../../common/utils'
import Field from '../../fields'
import { ResidentSelectOption } from '../../generic'
import PopupModal from '../../modals/PopupModal'

interface ZoneFormProps {
  formId: string
  residents: any[]
  isEdit: boolean
  onSubmit: () => void
  preferredPeopleNominative: string
  setFormField?: (field: { key: string; value: any }) => void
}

export class ZoneForm extends Component<ZoneFormProps> {
  render() {
    const {
      formId,
      isEdit,
      onSubmit,
      residents,
      preferredPeopleNominative,
      ...formProps
    } = this.props

    return (
      <PopupModal
        confirmText={isEdit ? 'Save' : 'Add'}
        buttonIcon={isEdit ? 'CheckOutlined' : 'PlusOutlined'}
        buttonColour="success"
        list="Zone"
        includesRequired
        onConfirm={onSubmit}
        style={{ overflowY: 'inherit' }}
        type={isEdit ? 'edit' : 'create'}
        {...formProps}
      >
        <Suspense fallback={<div>Loading...</div>}>
          <Field
            formId={formId}
            keys="name"
            label="Title"
            required
            // @ts-ignore
            values={formProps.fields}
            type="text"
          />
        </Suspense>
        <div style={{ paddingTop: 20 }}>
          <Suspense fallback={<div>Loading...</div>}>
            <Field
              formatOptionLabel={ResidentSelectOption}
              formId={formId}
              keys="residents"
              label={getNominative(preferredPeopleNominative, 'Residents')}
              options={sortList(residents, ({ status }) =>
                ['active', 'dummy'].includes(status)
              )}
              required
              type="multiSelect"
              // @ts-ignore
              values={formProps.fields}
            />
          </Suspense>
        </div>
      </PopupModal>
    )
  }
}

const mapStateToProps = (state: any) => {
  return {
    residents: state.data.residents,
    preferredPeopleNominative: state.global.home.preferredPeopleNominative
  }
}

export default connect(mapStateToProps, null)(ZoneForm)
